{
  "fr": {
    "datatable": {
      "actions": {
        "add_filter": "Ajouter un filtre",
        "bulk_action": "Action en masse",
        "bulk_edit": "Modification en masse",
        "clear": "Effacer",
        "clear_filters": "Effacer les filtres",
        "collapse_all": "Tout réduire",
        "collapse_row": "Réduire la ligne",
        "deselect_all": "Tout désélectionner",
        "expand_all": "Tout développer",
        "expand_row": "Développer la ligne",
        "filters": "Filtres",
        "remove_filter": "Supprimer le filtre {label} : {value}",
        "select_all": "Tout sélectionner",
        "select_row": "Sélectionner la ligne"
      },
      "import": {
        "error_row": "Ligne {row}",
        "errors_description": "L'import a été annulé car {count} ligne(s) contenaient des erreurs. Aucun enregistrement n'a été importé.",
        "errors_title": "Échec de l'import",
        "success": "Fichier importé avec succès",
        "title": "Importer"
      },
      "labels": {
        "active_filters": "Filtres actifs",
        "columns_selected": "{count} colonnes sélectionnées",
        "freeze_columns": "Figer les colonnes",
        "freeze_rows": "Figer les lignes",
        "gridlines": "Quadrillage",
        "group_by": "Regrouper par",
        "size": "Taille",
        "sticky_headers": "En-têtes fixes",
        "striped_rows": "Lignes zébrées",
        "toggle_columns": "Basculer les colonnes",
        "translation_mode_header": "En-tête",
        "translation_mode_stacked": "Empilé",
        "translation_mode_toolbar": "Global",
        "translation_style": "Style de traduction"
      }
    }
  }
}
